import { useAtom } from "jotai";
import { toastsAtom } from "./toaster.atom";

const useToastConsumer = () => {
  const [toasts] = useAtom(toastsAtom);

  return { state: toasts };
};

export default useToastConsumer;
